import { useState } from "react";
import useProducts from "./useProducts";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

export default function ProductsSelect({ onChangeProduct }) {
  const [search, setSearch] = useState('');

  const { data, loading } = useProducts({ search });

  const options = data?.map(item => {
    return {
      id: item.id,
      name: item.curso
    }
  })

  return (
    <Autocomplete
      options={options}
      loading={loading}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `[${option.id}] ${option.name}`}
      loadingText="Buscando produtos"
      noOptionsText="Nenhum produto encontrado"
      onChange={(e, newValue) => onChangeProduct(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Selecione o produto"
          value={search}
          onChange={e => setSearch(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={16} color="inherit" /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}